const clientPersonTypes = [
    {
        name: "CLIENT",
        value: 6
    },
    {
        name: "CUSTOMER",
        value: 7
    },
    {
        name: "PROJECT_MANAGER",
        value: 1
    },
    {
        name: "SITE_MANAGER",
        value: 8
    },
    {
        name: "ARCHITECT",
        value: 5
    },
    {
        name: "MANAGEMENT",
        value: 3
    },
    {
        name: "ACCOUNTING",
        value: 9
    },
    {
        name: "OTHER",
        value: 10
    },
]

export default clientPersonTypes;